<template>
    <div >
        <div style="position: relative;">
          <img class="AMZ_BACK_img" :src="$ossUrl+'images/Amz/AMZ_Slice.png'" alt="" >
          <div class="container" >
            <div class="special "  style="">
                <div class="flx-align-only-start">
                    <el-tabs v-model="activeRegistar" >
                      <el-tab-pane label="亚马逊TSPN" name="TSPN">
                       <TSPN></TSPN>
                      </el-tab-pane>
                      <el-tab-pane label="亚马逊SHIPTRACK" name="SHIPTRACK">
                       <SHIPTRACK></SHIPTRACK>
                      </el-tab-pane>
                      <el-tab-pane label="亚马逊SEND" name="SEND">
                       <SEND></SEND>
                      </el-tab-pane>
                    </el-tabs>
                </div>
            </div>
          </div>
          </div>
        <div v-if="activeRegistar==='TSPN'" style="background-color: #fcfcfc;padding: 80px 0 228px 36px;">
            <div  class="container">
                <div>
                    <div class="TSDN-Box-mainTitle">Transparency透明计划功能</div>
                    <el-row>
                        <el-col :span="12" v-for="(item,index) in TSDNList" :key="index">
                            <div class="TSDN-Box">
                                <div class="TSDN-Box-title">{{item.title}}</div>
                                <div class="TSDN-Box-content">{{ item.content }}</div>
                            </div>
                        </el-col>
                      
                    </el-row>
                </div>
                <div>
                
                  <div class="footer-Box flx-justify-between">
                    <div class="footer-Img">
                    <img :src="$ossUrl+'images/platform/megaphone.png'" alt="">
                  </div>
                  <div>
                    <div class="footer-title">Transparency透明计划</div>
                    <div class="footer-content">为了给卖家提供更好的品牌保护与成长方向的服务和体验，亚马逊推出了Transparency透明计划服务商网络（TSPN）。</div>
                    <div class="flx-only-align-center ">
                      <div class="footer-tip">售前 - 防止假货触达</div>
                      <div class="footer-tip">售中 - 提升销售转化</div>
                      <div class="footer-tip">售后 - 赋能品牌营销</div>
                    </div>
                  </div>
                  <div class="footer-Qrcode">
                    <img :src="$ossUrl+'images/footer/qrcodeAMZ_footer.png'" alt="">
                  </div>
                  </div>
                </div>
            </div>
        </div>
        <div v-else-if="activeRegistar==='SHIPTRACK'">
          <div style="background-color: #fcfcfc;padding: 80px 0 0  36px;">
            <div  class="container">
                <div>
                    <div class="TSDN-Box-mainTitle" style="margin-bottom: 100px;padding-left: 10px;">选择ShipTrack承运商的优势</div>
                    <el-row>
                        <el-col :span="24" v-for="(item,index) in ShipTrackList" :key="index" class="flx-justify-between" style="margin-bottom: 110px;padding: 0 20px;">
                            <div class="flx-center" >
                              <img :src="item.img" alt="" style="margin-right: 24px;">
                              <div class="TSDN-Box-title" style="margin-bottom: 0;">{{item.title}}</div>
                            </div>
                            <div class="TSDN-Box-content" style="width: 510px;">{{ item.content }}</div>
                        </el-col>
                      
                    </el-row>
                </div>
                <div>
                
            
                </div>
            </div>
          </div>
          <div  class="container" v-viewer style="margin-top: 83px;margin-bottom: 83px;">
            <div class="TSDN-Box-mainTitle" style="margin-bottom: 60px;padding-left: 30px;">如何选择美通作为承运商</div>
            <el-steps  direction="vertical" style="padding-left: 30px;">
               <el-step
                 v-for="step in steps"
                 :key="step.id"
               >
                 <template #description>
                   <div v-if="step.imageUrl1">
                     <div class="description">{{ step.description }}</div>
                       <img :src="step.imageUrl1" alt="步骤图片" style="margin: 24px 0;border-radius: 10px;border: 1px solid #DCDCDC"/>
                       <img :src="step.imageUrl2" alt="步骤图片" style="margin-bottom: 90px;border-radius: 10px;border: 1px solid #DCDCDC"/>
                   </div>
                   <div class="description" v-else style="margin-bottom: 42px;">{{ step.description }}</div>
                 </template>
               </el-step>
             </el-steps>
          </div>
        </div>
        <div v-else-if="activeRegistar==='SEND'">
          <div style="padding: 80px 0 0  0;">
            <div  class="container" style="margin-bottom: 70px;padding-left: 60px;">
                <div>
                    <div class="TSDN-Box-mainTitle" style="margin-bottom: 100px;padding-left: 10px;">Amazon SEND空运服务五大优势</div>
                    <el-row >
                        <el-col :span="7" class="SEND-Box SEND-Box1" style="background-color: #EEF9E2;">
                              <img :src="$ossUrl+'images/Amz/AMZ_green.png'" alt="">
                            <div class="SEND-Box-title" >履约稳定</div>
                            <div class="SEND-Box-content "  style="font-size: 12px;">
                              由亚马逊筛选的物流合作承运人提供服务，履约稳定。有效保障在规定时效内将货件送达运营中心，有助于达成入库缺陷率考核。
                            </div>
                        </el-col>
                        <el-col :span="14" class="SEND-Box SEND-Box2" style="background: #F1E6F6;">
                          <img :src="$ossUrl+'images/Amz/AMZ_purple.png'" alt="">
                              <div class="SEND-Box-title" >灵活高效</div>
                            <div class="SEND-Box-content " >
                              <div style="margin-bottom: 8px;">
                                <span style="width: 100px;display: inline-block;">服务：</span>
                                <span>无需注册，提供实时客服服务，操作灵活，仓位稳定灵活。   </span>
                              </div>
                              <div style="margin-bottom: 8px;">
                                <span style="width: 100px;display: inline-block;">运输方式：</span>
                                <span>起运量低，海空运灵活互补可以满足卖家不同的发货需求。   </span>
                              </div>
                              <div style="margin-bottom: 8px;">
                                <span style="width: 100px;display: inline-block;">时效：</span>
                                <span>多种服务时效可灵活选择，对比同等服务类型更快更高效。   </span>
                              </div>
                            </div>
                        </el-col>
                        <el-col :span="14" class="SEND-Box SEND-Box3" style="background: #FEEEDD;">
                          <img :src="$ossUrl+'images/Amz/AMZ_orange.png'" alt="">
                          <div class="SEND-Box-title" >价格优势</div>
                        <div class="SEND-Box-content " style="font-size: 12px;">
                          <div>卖家使用亚马逊协议价，价格比同时效的产品更低*，降低头程物流成本。      价格透明，无隐性费用，</div>
                          <div>免国内仓库**入仓费用及中转附加费。</div>
                          <div>* 对比承运商的同时期报价，具体以实时报价为准。</div>  
                          <div>** 国内承运商收货仓库。</div>
                        </div>
                    </el-col>
                    <el-col :span="7" class="SEND-Box SEND-Box4" >
                      <img :src="$ossUrl+'images/Amz/AMZ_yellow.png'" alt="">
                            <div class="SEND-Box-title" >优先入仓</div>
                            <div class="SEND-Box-content "  >
                              由亚马逊筛选的物流合作承运人提供服务，履约稳定。有效保障在规定时效内将货件送达运营中心，有助于达成入库缺陷率考核。
                            </div>
                        </el-col>
                        <el-col :span="21" class="SEND-Box SEND-Box5" style="  background: #EEFAFA;height: 120px;">
                            <div class="SEND-Box-title" >简化运营</div>
                            <div class="SEND-Box-content "  >
                              由合作承运人提供门到门全程服务和专业的清关服务，降低运营成本。此外，头程入仓流程一站式集成到卖家平台完成，从发/补货、订单追踪、入仓等全部可通过卖家平台实现，简化稳定更可靠。全国多个分拨中心*，卖家可以根据自己的货源地址就近入仓，订舱排舱更快捷，入库更方便。
                            </div>
                        </el-col>
                    </el-row>
                 
                </div>
                <div>
                </div>
            </div>
            <div style="background-color: #fcfcfc;padding:  80px 0px  70px  36px;" >
              <div class="container" style="">
                <div class="TSDN-Box-mainTitle" style="margin-bottom: 29px;padding-bottom: 30px;">Amazon SEND空运服务可满足哪些头程需求？</div>
                <div class="amazon-Box">
                  <div class="amazon-title">新品测试</div>
                  <div class="amazon-content">发货起运量要求低，少量测款减少不必要的试错成本，降低库存风险。</div>
                </div>
                <div class="amazon-Box">
                  <div class="amazon-title">紧急补货</div>
                  <div class="amazon-content">Amazon SEND空运派送英国站平均8.5天、派送德国站平均11-13天即可送达，可以帮忙卖家在大促期间等情况下紧急补货。</div>
                </div>
                <div class="amazon-Box " style="height: 210px;padding: 60px 0 60px 135px;margin-bottom:0;" >
                  <el-row class="">
                    <el-col :span="12" class="flx-justify-between " style="margin-bottom: 70px;">
                     <div class="flx-justify-between " style="width: 340px">
                      <div class="flx" style="">
                        <div class="amazon-country">
                          <img :src="$ossUrl+'images/platform/contry_connect1.png'" alt="">
                          中国 - 美国
                        </div>
                        <div class="amazon-trans">空运</div>
                      </div>
                      <div class="amazon-time">4-12天</div>
                     </div>
                    </el-col>
                    <el-col :span="12" class="flx-justify-between " style="margin-bottom: 70px;">
                     <div class="flx-justify-between " style="width: 340px">
                      <div class="flx" style="">
                        <div class="amazon-country">
                          <img :src="$ossUrl+'images/platform/contry_connect2.png'" alt="">
                          中国 - 英国
                        </div>
                        <div class="amazon-trans">空运</div>
                      </div>
                      <div class="amazon-time">8.5天</div>
                     </div>
                    </el-col>
                    <el-col :span="12" class="flx-justify-between " style="margin-bottom: 70px;">
                     <div class="flx-justify-between " style="width: 340px">
                      <div class="flx" style="">
                        <div class="amazon-country">
                          <img :src="$ossUrl+'images/platform/contry_connect3.png'" alt="">
                          中国 - 德国
                        </div>
                        <div class="amazon-trans">空运</div>
                      </div>
                      <div class="amazon-time">11-13天</div>
                     </div>
                    </el-col>
                    <el-col :span="12" class="flx-justify-between " style="margin-bottom: 70px;">
                     <div class="flx-justify-between " style="width: 340px">
                      <div class="flx" style="">
                        <div class="amazon-country">
                          <img :src="$ossUrl+'images/platform/contry_connect4.png'" alt="">
                          中国 - 日本
                        </div>
                        <div class="amazon-trans">空运</div>
                      </div>
                      <div class="amazon-time">5天</div>
                     </div>
                    </el-col>
                    <el-col :span="12" class="flx-justify-between " style="margin-bottom: 70px;">
                     <div class="flx-justify-between " style="width: 340px">
                      <div class="flx" style="">
                        <div class="amazon-country">
                          <img :src="$ossUrl+'images/platform/contry_connect5.png'" alt="">
                          中国 - 中东
                        </div>
                        <div class="amazon-trans">空运</div>
                      </div>
                      <div class="amazon-time">7-14天</div>
                     </div>
                    </el-col>
                    <el-col :span="12" class="flx-justify-between " style="margin-bottom: 70px;">
                     <div class="flx-justify-between " style="width: 340px">
                      <div class="flx" style="">
                        <div class="amazon-country">
                          <img :src="$ossUrl+'images/platform/contry_connect6.png'" alt="">
                          中国 - 澳洲
                        </div>
                        <div class="amazon-trans">空运</div>
                      </div>
                      <div class="amazon-time">5-15天</div>
                     </div>
                    </el-col>
                  </el-row>
                
                </div>
              </div>
            </div>
            <div class="container" v-viewer style="margin-top: 80px;">
              <div class="TSDN-Box-mainTitle" style="padding-bottom: 0px;">如何选择美通作为承运商</div>
              <div class="selectCarrier">现在进入卖家平台Send to Amazon页面，轻松四步即可开通Amazon SEND，解锁更快、更低成本、更稳定的发货体验！</div>
              <el-steps  direction="vertical" style="padding-left: 30px;">
               <el-step
                 v-for="step in stepsCarrier"
                 :key="step.id"
               >
                 <template #description>
                   <div v-if="step.imageUrl1&&step.imageUrl2">
                     <div class="description">{{ step.description }}</div>
                     <div class="content">{{ step.content1 }}</div>
                     <div class="content">{{ step.content2 }}</div>
                     <img  :src="step.imageUrl1" alt="步骤图片" style="margin: 24px 0;border-radius: 10px;border: 1px solid #DCDCDC"/>
                     <div class="content">{{ step.content3 }}</div>
                     <img :src="step.imageUrl2" alt="步骤图片" style="margin-top: 20px;margin-bottom: 24px;border-radius: 10px;border: 1px solid #DCDCDC"/>
                     <div class="content">{{ step.content4 }}</div>
                     <img :src="step.imageUrl3" alt="步骤图片" style="margin-top: 20px;margin-bottom: 24px;border-radius: 10px;border: 1px solid #DCDCDC"/>



                   </div>
                   <div  v-else-if="step.imageUrl1" style="">
                    <div class="description">{{ step.description }}</div>
                    <img :src="step.imageUrl1" alt="步骤图片" style="margin-top: 20px; margin-bottom: 90px;border-radius: 10px;border: 1px solid #DCDCDC"/>
                  </div>
                  <div v-else>
                    <div class="description" style="margin-bottom: 135px;">{{ step.description }}</div>
                  </div>
                 </template>
               </el-step>
             </el-steps>
             <div class="TSDN-Box-mainTitle" style="padding-bottom: 0px;margin-top: 80px;">观看视频，轻松get教程</div>
             <div class="video">
                    <video autoplay  muted playsinline style="height: 100%;">
                        <source src="https://public-aaf-shenzhen-file.oss-cn-beijing.aliyuncs.com/aaf1.0/ui/media/send_guide.mp4" type="video/mp4"  >
                        Your browser does not support the video tag.
                      </video>
             </div>
            </div>
            <div style="background-color: #fcfcfc;padding:  80px 0px  70px  36px;" >
              <div class="container" style="margin-bottom: 70px;">
                <div class="TSDN-Box-mainTitle" style="margin-bottom: 29px;padding-bottom: 30px;">常见问答</div>
                <el-row class="faq-container" >
                  <el-col v-for="(faq, index) in faqs" :key="index" :span="24">
                    <div class="faq-item" >
                      <h3>{{ faq.question }}</h3>
                        <div class="faq-answer show-ellipsis">
                           <i>答</i>  {{ faq.answer }}
                        </div>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
     
        </div>
    </div>
</template>
<script>
import TSPN from "./TSPN.vue";
import SHIPTRACK from "./SHIPTRACK.vue";
import SEND from "./SEND.vue";

/**
 * Index-1 component
 */
export default {
    name:"AMZDetail",
  components: {
    TSPN,
    SHIPTRACK,
    SEND,
  },
  created(){
    this.activeRegistar = this.$route.query.select;
  },
  data(){
    return {
      activeRegistar:'TSPN',
      TSDNList:[
        {
          title:"Listing创建",
          content:"开启保护的商品，其他商家想上架相同商品，必须提供对应的Transparency代码，才能正常上架或跟卖。",
        },
        {
          title:"亚马逊物流（FBA）商品入仓",
          content:"亚马逊会扫描每件产品的Transparency代码，仅接受正品商品入库。",
        },
        {
          title:"自配送商品销售",
          content:"自配送商品也必须提供对应的Transparency代码才可销售。",
        },
        {
          title:"吸睛“小蓝标”",
          content:"获得商品详情 Transparency透明计划标记，能快速区别于其他商品，帮助提高转化。",
        },
        {
          title:"小卡片",
          content:"在商品中放入定制卡片，和买家进行互动，沉淀品牌用户。",
        },
        {
          title:"互动页面",
          content:"能帮助精准营销、引导留评、提升粉丝粘性、增加商品复购率。",
        },
        {
          title:"退货分析报表",
          content:"按生产批次、经销商或单个产品，查看消费者退货的原因。",
        },
      ],
      ShipTrackList:[
        {
          title:"无需手动输入追踪编码，简化入仓流程，提升入仓效率",
          img:this.$ossUrl+'icons/platform/shipt1.png',
          content:"卖家不必提供PRO/SPD追踪编码，美通系统已与亚马逊后台对接，美通系统将自动填入，后台自动实时更新物流节点。",
        },
        {
          title:"提供主要追踪节点，提高追踪透明度",
          img:this.$ossUrl+'icons/platform/shipt2.png',
          content:"提供国内入仓、报关放行、开船、到港、清关放行、提柜预约派送、派送日期等全节点的轨迹信息，实时透明，全程追踪。",
        },
      ],
      activeStep: 1,
      steps: [
        {
          description:"后台创建货件时，下拉“选择运输承运人”列表，点击“美通（ShipTrack）”。",
          imageUrl1:this.$ossUrl+'images/platform/ShipTrack-1.png',
          imageUrl2:this.$ossUrl+'images/platform/ShipTrack-2.png',
        },
        {
          description:"提供完整的Shipment ID和Reference ID。",
        },
        {
          description:"在亚马逊卖家中心的“货件一览”页面“追踪货件”，自动收到推送并查看物流轨迹。",
        },
        // ...其他步骤
      ],
      stepsCarrier: [
        {
          description:"创建货件",
          content1:"登录卖家平台",
        },
        {
          description:"选择“库存”菜单中的“货件”选项",
          imageUrl1:this.$ossUrl+'images/platform/ShipTrack-3.webp',
        },
        {
          description:"进入Send to Amazon，开始创建亚马逊FBA货件",
          content1:"1.确认要发送的库存",
          content2:"2.配送模式和承运人",
          content3:"3.货件打标",
          content4:"4.货件追踪",
          imageUrl1:this.$ossUrl+'images/platform/ShipTrack-4.webp',
          imageUrl2:this.$ossUrl+'images/platform/ShipTrack-5.webp',
          imageUrl3:this.$ossUrl+'images/platform/ShipTrack-6.webp',

        },
        // ...其他步骤
      ],
      faqs: [
      {
        question: '同一账号可以同时使用AGL和Amazon SEND吗？',
        answer: '可以的。这两种头程物流方式互相补充。AGL与Amazon SEND是分别由亚马逊全球物流及亚马逊筛选的第三方物流提供的跨境物流服务。'
      },
      {
        question: 'Amazon SEND包含哪些服务？',
        answer: '目前Amazon SEND为卖家提供海运及空运服务，包含提货(如需)、出口报关、干线空运、进口清关以及末端派送等。对于还未开通提货服务的地区，卖家可以选择自送货，Amazon SEND承运商会提供收货仓库地址、联系方式等信息，卖家可就近送货到SEND承运商仓库。'
      },
      {
        question: 'Amazon SEND的价格是多少？',
        answer: '根据不同物流商及时效会有变动，请关注实时价格。但相较于使用线下第三方物流，Amazon SEND价格比同时效的产品更低。（* 对比承运商的同时期报价，具体以实时报价为准。）'
      },
      
      // 其他的FAQ对象...
    ]
    }
  },
  methods: {
   
  }
};
</script>
<style src="./componentsIndex.css" scoped>

</style>